import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import type { Timestamp } from 'firebase/firestore';
import { db } from '@/backend/lib/firebase';

export interface ContactSettings {
  addressLine1: string;
  addressLine2: string;
  phone: string;
  email: string;
  officeHours: string;
  updatedAt?: Timestamp;
  updatedBy?: string;
}

export const DEFAULT_CONTACT_SETTINGS: ContactSettings = {
  addressLine1: 'Av. Duque de Ávila 95, 3º',
  addressLine2: '1000-139 Lisboa, Portugal',
  phone: '+351 93 221 10 11',
  email: 'geral@home2students.com',
  officeHours: 'Mon-Fri 9am-6pm',
};

// Reused by the footer and contact page so the link derivation lives in one place.
export const toTelHref = (phone: string) => `tel:${phone.replace(/[^\d+]/g, '')}`;
export const toMailtoHref = (email: string) => `mailto:${email.trim()}`;

const SETTINGS_REF = () => doc(db, 'settings', 'contact');

export async function getContactSettings(): Promise<ContactSettings> {
  const snap = await getDoc(SETTINGS_REF());
  if (!snap.exists()) return { ...DEFAULT_CONTACT_SETTINGS };
  const data = snap.data() as Partial<ContactSettings>;
  return {
    addressLine1: data.addressLine1?.trim() ? data.addressLine1 : DEFAULT_CONTACT_SETTINGS.addressLine1,
    addressLine2: data.addressLine2?.trim() ? data.addressLine2 : DEFAULT_CONTACT_SETTINGS.addressLine2,
    phone: data.phone?.trim() ? data.phone : DEFAULT_CONTACT_SETTINGS.phone,
    email: data.email?.trim() ? data.email : DEFAULT_CONTACT_SETTINGS.email,
    officeHours: data.officeHours?.trim() ? data.officeHours : DEFAULT_CONTACT_SETTINGS.officeHours,
    updatedAt: data.updatedAt,
    updatedBy: data.updatedBy,
  };
}

export async function updateContactSettings(
  data: Partial<ContactSettings>,
  updatedBy: string,
): Promise<void> {
  await setDoc(
    SETTINGS_REF(),
    { ...data, updatedAt: serverTimestamp(), updatedBy },
    { merge: true },
  );
}
